module.exports = __webpack_public_path__ + "img/hashicon.224e4752.svg";